import { Box, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { TextSemiBold, TextRegular } from 'UiKit/typography';
import { ArrowLeftIcon } from 'Asset/icon';
import { pageDescription, pageTitle } from 'Const/reset-password';

import styles from './styles.module.css';

const Head = () => {
  const navigate = useNavigate();

  return (
    <Box className={styles['section-head__container']}>
      <Flex className={styles['section-head__container--top']}>
        <ArrowLeftIcon size="26px" onClick={() => navigate('/login')} role="button" />
        <TextSemiBold className={styles['page__title']}>{pageTitle}</TextSemiBold>
      </Flex>
      <TextRegular className={styles['description__text']}>{pageDescription}</TextRegular>
    </Box>
  );
};

export default Head;
